import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAppEnv } from './config/env';

const firebaseConfig = {
  apiKey: getAppEnv('REACT_APP_FIREBASE_API_KEY'),
  authDomain: getAppEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: getAppEnv('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getAppEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getAppEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getAppEnv('REACT_APP_FIREBASE_APP_ID'),
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
